
const errorHandler = (info: any) => {
  let error = JSON.parse(JSON.stringify(info))
  console.log(error)
  let reason: string | undefined
  reason = error.reason ?? error.data?.message ?? error.message ?? reason??error.shortMessage
  console.log('reason::: ', reason);

  // if (reason?.indexOf('execution reverted: ') === 0) reason = reason.substring('execution reverted: '.length)
  if (reason === 'insufficient funds for intrinsic transaction cost') return `钱包资金不足`
  if (reason === 'missing revert data in call exception; Transaction reverted without a reason string') return `网络错误`
  if (reason === 'missing response') return `网络错误`
  if(reason === 'could not detect network') return `网络错误`
  return reason
}

export default errorHandler